import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { individualCreatorPausePath, individualCreatorStagePath, newAccountPath } from "@travily/routes";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { IndividualPrivacyStepView, type PrivacyChoice } from "./show.view";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  visibility: "public" | "private" | "hidden";
}

const IndividualPrivacyStep = ({ stage_index, stage_order, visibility }: PageProps) => {
  const initial: PrivacyChoice = visibility === "private" ? "private" : "public";

  const { form, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } = useWizardForm<{
    visibility: PrivacyChoice;
  }>({
    routes: {
      stageUrl: (stage) => individualCreatorStagePath(stage),
      entryUrl: newAccountPath(),
      pauseUrl: individualCreatorPausePath(),
    },
    stageName: "privacy",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { visibility: initial },
  });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.individuals.creator.steps.privacy.show.meta_title")}>
        <meta name="description" content={t("web.individuals.creator.steps.privacy.show.meta_description")} />
      </Head>
      <IndividualPrivacyStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        value={form.data.visibility}
        onChange={(value) => form.setData("visibility", value)}
      />
    </>
  );
};

export default IndividualPrivacyStep;
